
import React from 'react'
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../../redux/library/selector';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import MediaInfoComponent from '../../../../../../common/components/common/media-info.component';



export default function BlogPostBasicInfoComponent({ mediaFiles, handleFormItemChange, changeImage, handleInnerFormChange, selectedBlog }: any) {
  const libraryData = useSelector(selectListItems)
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
            <InputContainer
              label="Title"
              labelField="Title"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Title'
                );
              }}
              type="text"
              value={selectedBlog?.Title}
            />
            <InputContainer
              label="Caption"
              labelField="Caption"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'Caption'
                );
              }}

              type="text"
              value={selectedBlog?.Caption}
            />
            <InputContainer
              label="MetaKeywords"
              labelField="MetaKeywords"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MetaKeywords'
                );
              }}

              type="text"
              value={selectedBlog?.MetaKeywords}
            />
            <InputContainer
              label="MetaDescription"
              labelField="MetaDescription"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MetaDescription'
                );
              }}

              type="text"
              value={selectedBlog?.MetaDescription}
            />
            <InputContainer
              label="MetaTitle"
              labelField="MetaTitle"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'MetaTitle'
                );
              }}

              type="text"
              value={selectedBlog?.MetaTitle}
            />
            <InputContainer
              label="BlogShow Start Date"
              labelField="BlogShowStartDateUtc"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'BlogShowStartDateUtc'
                );
              }}
              type="date"
              value={selectedBlog?.BlogShowStartDateUtc}
            />
            <InputContainer
              label="BlogShow End Date"
              labelField="BlogShowEndDateUtc"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'BlogShowEndDateUtc'
                );
              }}
              type="date"
              value={selectedBlog?.BlogShowEndDateUtc}
            />
            <InputContainer
              label="Comments Allowed"
              labelField="IsCommentsAllowed"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event,
                  'IsCommentsAllowed'
                );
              }}
              type="checkbox"
              value={selectedBlog?.IsCommentsAllowed}
            />
            <InputContainer
              label="Limited To Stores"
              labelField="IsLimitedToStores"
              onValueChange={(event: any, newValue: any) => {
                handleInnerFormChange(
                  event,
                  'IsLimitedToStores'
                );
              }}
              type="checkbox"
              value={selectedBlog?.IsLimitedToStores}
            />
            <div className='col-span-full'>
              <InputContainer
                label="Body"
                name="Body"
                onValueChange={(event: any) => {
                  handleInnerFormChange(
                    event.target.value,
                    'Body'
                  )
                }}
                type="text"
                value={selectedBlog?.Body}
              /></div>
          </div>
        }
        expandedPanel="BasicInfo"
        headerTitle="Basic Info"
      />
      <AccordionContainer
        child={
          <div>
            <MediaInfoComponent
              changeImage={changeImage}
              fileTypes={libraryData?.result?.FileType}
              onFormItemChange={handleFormItemChange}
              mediaFiles={mediaFiles}
            />
          </div>
        }
        expandedPanel="Blog Post Media"
        headerTitle="BlogPost Media Info"
      />
    </>
  )
}